// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__c8RvL","row":"Node_row__1Bm1E","label":"Node_label__XPKHS","footer":"Node_footer__um9uU"};